import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => {
  const { marginLR, paddingLR } = theme.mixins;

  return {
    Top10Events: {
      display: 'flex',
      flexDirection: 'column',
      gap: pxToRem(48),
      padding: pxToRem(120) + ' 5.75% ' + pxToRem(130),
      overflowX: 'hidden',
      '&.withBG': {
        padding: pxToRem(64) + ' 5.75% ' + pxToRem(130),
        [theme.breakpoints.down('md')]: {
          padding: pxToRem(40) + ' 1.5rem ' + pxToRem(40),
        },
      },
      [theme.breakpoints.down('md')]: {
        padding: pxToRem(40) + ' ' + pxToRem(24) + ' ' + pxToRem(40),
        gap: pxToRem(32),
      },

      '& .eventsTitle': {
        fontFamily: theme.custom.fontFamily.primaryBold,
        fontWeight: '400',
        position: 'relative',
        color: theme.palette.common.white,
        fontStyle: "normal",
        lineHeight: pxToRem(40),

        '@media (max-width: 768px)': {
          fontSize: pxToRem(26),
          lineHeight: pxToRem(32),
        },

        '@media (max-width: 375px)': {
          fontSize: pxToRem(22),
        },
      },

      '& .eventsCTA': {
        fontSize: pxToRem(22),

        '&.mobile': {
          display: 'none',
        },

        '& .MuiButton-endIcon': {
          ...theme.mixins.marginLeft(22),
        },

        '@media (max-width: 767px)': {
          fontSize: pxToRem(16),
          '& .MuiButton-endIcon': {
            ...theme.mixins.marginLeft(16),
          },

          '&.desktop': {
            display: 'none',
          },

          '&.mobile': {
            color: theme.palette.common.white,
            display: 'inline-flex',
          },
        },
      },

      '& .slick-slider': {
        width: '100vw',
        ...theme.mixins.marginLeft('-5.75vw'),
        paddingLeft: pxToRem(171), // Need same on rtl thats why no paddingnLR
        paddingRight: pxToRem(11), // Need same on rtl thats why no paddingnLR

        '& .slick-list': {
          overflow: 'visible',
        },
      },
    }
  };
});

export default useStyles;
